import React from 'react';
import '../styles/LynxPage.css'; // We'll create this next

const LynxPage = () => {
  return (
    <div className="lynx-page-container">
      <header className="lynx-header">
        <h1>Lynx: Your Personal AI Assistant - 100% Private & Offline</h1>
        <p>Finally, an AI assistant that respects your privacy. Get intelligent help with writing, questions, brainstorming, and daily tasks - all without sharing your personal conversations with anyone.</p>
      </header>

      <section className="lynx-section">
        <h2>Complete Privacy Protection</h2>
        <p>Unlike other AI apps that send your data to remote servers, everything happens directly on your phone. Your conversations, questions, and personal information never leave your device. No accounts required, no data collection, no tracking.</p>
      </section>

      <section className="lynx-section">
        <h2>Works Anywhere, Anytime</h2>
        <ul>
          <li>Full offline functionality - no internet connection needed</li>
          <li>Instant responses without waiting for servers</li>
          <li>Perfect for travel, commuting, or areas with poor connectivity</li>
          <li>Always available when you need help</li>
        </ul>
      </section>

      <section className="lynx-section">
        <h2>Everyday Use Cases</h2>
        <ul>
          <li>Get quick answers and explanations</li>
          <li>Writing assistance and proofreading</li>
          <li>Creative brainstorming and idea generation</li>
          <li>Learning support and study help</li>
          <li>Personal coaching and advice</li>
          <li>Planning and organization tasks</li>
        </ul>
      </section>

      <section className="lynx-section">
        <h2>Simple & Secure</h2>
        <p>No technical setup required. Just download, open, and start chatting. The app runs entirely on your device using advanced on-device AI technology, ensuring your privacy while delivering fast, helpful responses.</p>
      </section>

      <section className="lynx-section">
        <h2>Why Choose Private AI?</h2>
        <p>Take control of your digital privacy without sacrificing functionality. Perfect for students, professionals, creatives, and anyone who values confidential, secure AI assistance.</p>
      </section>

      <section className="lynx-section">
        <h2>System Requirements</h2>
        <p>Compatible with modern smartphones.</p>
      </section>

      <footer className="lynx-footer">
        <h2>Terms & Privacy</h2>
        <p>This app includes Apple's standard End User License Agreement (EULA). <a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/" target="_blank" rel="noopener noreferrer">https://www.apple.com/legal/internet-services/itunes/dev/stdeula/</a></p>
      </footer>
    </div>
  );
};

export default LynxPage;